import { createActions } from '../../../context';
import * as actions from './course-details.actions';

export const courseDetails = store => ({
	course: {
		providerId: '',
		id: '',
		name: '',
		url: '',
		enabled: false,
		timeZone: '',
		address: '',
		city: '',
		state: '',
		zipCode: '',
		latitude: '',
		longitude: '',
		description: '',
		amenities: '',
		slope: '',
		clubName: '',
		currency:'',
		country:'',
		countryCodeValid: false,
		teesheetIntegration: true,
	},
	classes: [],
	classGroups: [],
	tradeTypes: [],
	configuration: {},
	passId: null,
	ruleDetails: [],
	teetimeRequestURL:"",
	teetimeResponseDetails: [],
	countries:{},
	actions: createActions(actions)(store)
});
